var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"my-3",attrs:{"value":_vm.value,"label":_vm.$t('text.email'),"rules":_vm.emailRules,"required":"","outlined":"","loading":_vm.validationLoading,"dense":""},on:{"input":e => _vm.$emit('input', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }